import emojiRegex from 'emoji-regex'

export default emojiRegex()
